import React from 'react';

const BasketballCourt: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    className="relative w-full rounded-2xl overflow-hidden mb-3"
    style={{
      backgroundImage: `url('/court-bg.png')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center top',
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#C8935A',
    }}
  >
    {children}
  </div>
);

export default BasketballCourt;
